import Vue from "vue";
import _ from "lodash";
import qs from "qs";

const URL = "/db/area";
const API_URL = URL + "/api/";

const state = {
  area: [],
  area_loaded: false
};

const getters = {
  areaInjected(state) {
    return state.area;
  },
  areaByLaman(state, getters, rootState) {
    return state.area.filter(a => a.id_laman == rootState.id_laman$);
  }
};

const mutations = {
  LOADED(state, payload) {
    state.area_loaded = payload;
  },
  SET_AREA(state, payload) {
    state.area = payload;
  },
  ADD_AREA(state, payload) {
    state.area.push(payload);
  },
  UPDATE_AREA(state, payload) {
    state.area = _.unionBy([payload], state.area, "id_area");
  },
  DELETE_AREA(state, ids) {
    _.remove(state.area, function(area) {
      return ids.includes(area.id_area);
    });
    state.area = [...state.area];
  }
};

const actions = {
  GET_OPTIONS({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(URL + "/options").then(res => {
      commit("laman/SET_LAMAN", res.data.laman, { root: true });
      commit("LOADING_DONE", null, { root: true });
    });
  },
  GET_AREA({ commit }) {
    commit("LOADING", null, { root: true });
    commit("LOADED", false);
    return Vue.axios.get(API_URL).then(res => {
      commit("LOADED", true);
      commit("SET_AREA", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  },
  ADD_AREA({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL, qs.stringify(payload))
      .then(res => {
        commit("ADD_AREA", res.data);
        commit("SUCCESS", "Berhasil menambah...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  UPDATE_AREA({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .put(API_URL + payload.id_area, qs.stringify(payload))
      .then(res => {
        commit("UPDATE_AREA", res.data);
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, { root: true });
        throw e;
      });
  },
  DELETE_AREA({ commit }, payload) {
    let ids = payload.map(p => p.id_area).join(",");
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .delete(API_URL + ids)
      .then(res => {
        commit("DELETE_AREA", res.data.ids);
        if (typeof res.data.errors !== "undefined")
          commit("ERROR", res.data.errors, { root: true });
        else commit("SUCCESS", "Berhasil menghapus...", { root: true });
        return res.data.ids;
      })
      .catch(() => {
        commit("ERROR", "Data masih dipakai di tabel lain!", {
          root: true
        });
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
